module.exports = __webpack_public_path__ + "static/media/aboutus_rectangle.6c1cd0cf.png";